import * as R from 'ramda';
import { extractFreqColumnsAndCategoryCol } from 'calculators/dataset/frequencyTable';

const addRowIndexAndHandleEmptyCell = dataset => {
  const parseToTheEmptyValue = value => (value === 'empty' ? '' : value);
  const parseToTheEmptyRow = R.map(parseToTheEmptyValue);

  return dataset.map((row, index) => ({
    ...parseToTheEmptyRow(row),
    rowIndex: index + 1
  }));
};

const validateCategorical = key => {
  return ({ [key]: value }) => {
    return value && value.length >= 100
      ? 'You have exceeded the maximum character limit.'
      : true;
  };
};
const validateNumerical = () => true;

const formatColumnHeadersForMaterialTable = (filteredDataset, parameters, colsToOmit) => {
  const rowKeys = R.keys(R.omit(colsToOmit, filteredDataset[0]));
  return rowKeys.map(key => {
    const {
      [key]: { targetType }
    } = parameters;

    const isNumerical = targetType === 'numerical';
    const validate = isNumerical ? validateNumerical : validateCategorical(key);

    return {
      title: key,
      field: key,
      width: 'auto',
      type: isNumerical ? 'numeric' : 'string',
      validate
    };
  });
};

const formatFrequencyColumnHeadersForMaterialTable = (filteredDataset, parameters, colsToOmit, nameForColumns) => {
  const { categoryColumn, orderedColumns } = extractFreqColumnsAndCategoryCol(filteredDataset, colsToOmit);
  return orderedColumns.map(colName => {
    const {
      [colName]: { targetType }
    } = parameters;

    const isNumerical = targetType === 'numerical';
    const validate = isNumerical ? validateNumerical : validateCategorical(colName);

    let colTitle = colName;
    // Prefix Common Name for all frequency columns
    if (nameForColumns && colName !== categoryColumn) {
      colTitle = `${nameForColumns}: ${colName}`;
    }
    if (!nameForColumns && colName !== categoryColumn) {
      colTitle = `${colName}`;
    }

    return {
      title: colTitle,
      field: colName,
      width: 'auto',
      type: isNumerical ? 'numeric' : 'string',
      validate
    };
  });
};

export {
  addRowIndexAndHandleEmptyCell,
  formatColumnHeadersForMaterialTable,
  formatFrequencyColumnHeadersForMaterialTable
};
